import { useEffect, useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import getColour from '@lendi-ui/commons/colours';

import { Body, Heading } from '../Typography';

type Props = { percentage: number };

const CompletionDonut = ({ percentage }: Props) => {
  const circumference = 2 * Math.PI * 47; // calculate the circumference of the circle
  const dashoffset = circumference * (1 - percentage / 100); // calculate the stroke-dashoffset

  // store the last percentage
  const lastPercentage = useRef(percentage);

  // create a keyframes animation
  const animateStroke = keyframes`
    from {
      stroke-dashoffset: ${circumference * (1 - lastPercentage.current / 100)};
    }
    to {
      stroke-dashoffset: ${dashoffset};
    }
  `;

  // update the last percentage after rendering
  useEffect(() => {
    lastPercentage.current = percentage;
  }, [percentage]);

  // create a styled component for the circle
  const AnimatedCircle = styled.circle`
    stroke-dasharray: ${circumference};
    stroke-dashoffset: ${circumference};
    animation: ${animateStroke} 0.6s ease-out forwards;
  `;

  return (
    <svg
      width="130"
      height="130"
      viewBox="0 0 120 120"
      style={{ transform: 'rotate(-90deg)' }}
      shapeRendering="geometricPrecision"
    >
      <circle cx="60" cy="60" r="47" fill="none" stroke="#f5f5f5" strokeWidth="2" shapeRendering="geometricPrecision" />
      <AnimatedCircle
        cx="60"
        cy="60"
        r="47"
        fill="none"
        stroke={`${getColour('fill', 'contrast')}`}
        strokeWidth="6"
        strokeLinecap="round"
        shape-rendering="geometricPrecision"
      />
      <g transform="rotate(90,80,80)">
        <foreignObject x="22" y="80" width="72" height="100">
          <div className="flex flex-col items-center">
            <Heading size="md" align="center">{`${!isNaN(percentage) ? percentage : 0}%`}</Heading>
            <Body size="xs" align="center">
              completed
            </Body>
          </div>
        </foreignObject>
      </g>
    </svg>
  );
};

export default CompletionDonut;
